import { ModalContext } from "../providers";
import { useContext, useEffect } from "react";

export type ModalOptions = {
  onCloseRequested?: () => void;
};

export function useModalDialog() {
  const modal = useModal();

  function show(Component: React.FC<{}>): void;
  function show<TProps extends object>(Component: React.FC<TProps>, props: TProps): void;
  function show<TProps extends object>(Component: React.FC<TProps>, props?: TProps) {
    return modal.show(<Component {...(props as TProps)} />);
  }

  return { ...modal, show };
}

export function useModal(options?: ModalOptions) {
  const modal = useContext(ModalContext);

  useEffect(() => {
    if (modal.closeRequested) {
      if (options?.onCloseRequested) {
        options.onCloseRequested();
      } else {
        modal.close();
      }
    }
  }, [modal.closeRequested, options?.onCloseRequested]);

  return modal;
}
